// Хаб «Мои партии»: история, новая игра, удаление, разбор и серверный шаринг.
import { coachGameFromPgn } from '../core/pgn-import';
import { t, currentLang } from '../i18n';
import { state, setPgnGame } from '../state';
import { alertMsg, hideMainButton, shareText, showBackButton } from '../tg';
import { deleteMyGame, fetchSharedMyGame, listMyGames, publishMyGame, readMyGame, renameMyGame, type MyGameMeta } from '../services/my-games';

const BOT_LINK = 'https://t.me/ChessAnalysis_by_ChessCoach_bot/analysis';
const esc = (s: string) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]!);

function goTrain(): void { location.hash = state.nick && state.games.length ? '#/train' : '#/'; }

function card(meta: MyGameMeta): string {
  const date = new Date(meta.date).toLocaleDateString(currentLang(), { day: 'numeric', month: 'short', year: 'numeric' });
  const shareLabel = currentLang() === 'ru' ? 'Отправить другу' : t('my.share');
  return `<article class="card my-game-card" data-id="${esc(meta.id)}">
    <button type="button" class="my-game-open grow" data-open><strong>${esc(meta.title || meta.opponent || t('my.engine'))}</strong>
      <span class="muted">${esc(date)} · ${esc(meta.result || '*')}</span></button>
    <div class="my-game-actions"><button type="button" class="ghost-btn" data-rename aria-label="Edit name">✎</button>
      <button type="button" class="ghost-btn danger" data-delete aria-label="${t('my.delete')}">×</button></div>
    <div class="my-rename hidden" data-rename-row><input maxlength="64" value="${esc(meta.title || '')}" placeholder="${esc(meta.opponent || t('my.engine'))}"><button type="button" class="ghost-btn" data-rename-save>✓</button></div>
    <button type="button" class="ghost-btn my-share-btn" data-share>↗ ${shareLabel}</button></article>`;
}

export function renderMyGames(root: HTMLElement): void {
  root.className = 'app v2';
  root.innerHTML = `<header class="topbar"><span class="back" data-back>${t('top.back')}</span><span class="top-title">${t('my.title')}</span><span></span></header>
    <section class="train-hero"><div class="eyebrow">${t('my.eyebrow')}</div><h1>${t('my.header')}</h1><p class="muted">${t('my.subtitle')}</p></section>
    <button type="button" class="inline-cta my-new" data-new>${t('my.new')}</button><section class="my-games-list" data-list><p class="muted">${t('my.loading')}</p></section>`;
  hideMainButton(); showBackButton(goTrain);
  root.querySelector('[data-back]')?.addEventListener('click', goTrain);
  root.querySelector('[data-new]')?.addEventListener('click', () => { location.hash = '#/train/my/new'; });
  const list = root.querySelector<HTMLElement>('[data-list]')!;
  void listMyGames().then((items) => {
    if (!location.hash.startsWith('#/train/my')) return;
    list.innerHTML = items.length ? items.map(card).join('') : `<section class="card state-card"><span class="icon">♟</span><p class="muted">${t('my.empty')}</p></section>`;
    list.querySelectorAll<HTMLElement>('[data-id]').forEach((el) => {
      const id = el.dataset.id!;
      el.querySelector('[data-open]')?.addEventListener('click', async () => {
        const pgn = await readMyGame(id); if (!pgn) return alertMsg(t('my.load_error'));
        setPgnGame(coachGameFromPgn(pgn)); state.gameBackHash = '#/train/my'; location.hash = `#/game/${state.selectedId}`;
      });
      el.querySelector('[data-delete]')?.addEventListener('click', async () => { await deleteMyGame(id); renderMyGames(root); });
      el.querySelector('[data-rename]')?.addEventListener('click', () => el.querySelector('[data-rename-row]')?.classList.toggle('hidden'));
      el.querySelector('[data-rename-save]')?.addEventListener('click', async () => {
        const input = el.querySelector<HTMLInputElement>('[data-rename-row] input')!;
        await renameMyGame(id, input.value); renderMyGames(root);
      });
      el.querySelector('[data-share]')?.addEventListener('click', async () => {
        const pgn = await readMyGame(id); if (!pgn) return;
        const meta = items.find((item) => item.id === id);
        try { const sharedId = await publishMyGame(pgn, meta?.title); await shareText(meta?.title || t('my.share_text'), `${BOT_LINK}?startapp=my_${sharedId}`); }
        catch { alertMsg(t('my.share_error')); }
      });
    });
  });
}

export function renderSharedMyGame(root: HTMLElement, id: string): void {
  root.className = 'app v2'; hideMainButton(); showBackButton(() => { location.hash = '#/'; });
  root.innerHTML = `<header class="topbar"><span class="top-title">${t('my.shared_title')}</span></header><section class="card state-card"><span class="skel-pill"></span><p class="muted">${t('my.loading')}</p></section>`;
  void fetchSharedMyGame(id).then((pgn) => {
    const parsed = coachGameFromPgn(pgn); setPgnGame(parsed, true); location.hash = `#/game/${parsed.id}`;
  }).catch(() => { root.innerHTML = `<section class="card state-card"><span class="icon">😕</span><p class="muted">${t('my.shared_error')}</p></section>`; });
}
